import React from 'react';
import styled from 'styled-components';

import { Caution } from 'assets/icons';
import { ExternalLink } from 'components/Common';
import { colorScale, typography } from 'themes';

import { ContentWrapper } from '../sharedStyles';

import { StyledArrowRight, iconStyles } from './sharedStyles';

const Wrapper = styled.div`
  background: ${colorScale('supporting-yellow', 10)};
  cursor: pointer;
`;

const StyledContentWrapper = styled(ContentWrapper)`
  color: ${colorScale('supporting-yellow', 50)};
  gap: 16px;

  p {
    margin: 0;
    width: 100%;
    ${typography('body-m')};

    svg {
      margin-left: 0;
    }

    a {
      &[href] {
        color: ${colorScale('supporting-yellow', 50)};

        &:visited {
          color: ${colorScale('supporting-yellow', 50)};
        }

        &:visited svg {
          color: ${colorScale('supporting-yellow', 50)};
          fill: ${colorScale('supporting-yellow', 50)};
        }
      }
    }
  }
`;

const StyledCaution = styled(Caution)`
  ${iconStyles}
`;

export const GOISBanner = () => {
  const GOIS_URL = 'https://www.mom.gov.sg/transact-safely-and-securely';

  const handleOnClick = () => {
    window.open(GOIS_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <Wrapper onClick={handleOnClick}>
      <StyledContentWrapper>
        <StyledCaution />
        <p>
          Government officials will <b>never</b> ask you to transfer money or disclose bank log-in
          details over a phone call or email. Call the 24/7 ScamShield Helpline at 1799 if you are
          unsure if something is a scam. Find out more on how to{' '}
          <ExternalLink url={GOIS_URL}>transact safely and securely</ExternalLink>.
        </p>
        <StyledArrowRight />
      </StyledContentWrapper>
    </Wrapper>
  );
};
